import { reflectKeys } from "@utils/key.reflactor";

export const NAMESPACE = {
  APP: "app",
  AUTH: "auth",
};
export const ERROR_CODE = {
  PASTCLASS: "PASTCLASS",
  ATTEMPTED: "ATTEMPTED",
  ASSIGNMENT_RESTORING: "assignment-restoring",
  ASSIGNMENT_CONTENT_MASTERY_PROCESSING: "assignment-content-mastery-processing",
};

export const RESTRICTION = {
  SUBGROUP: "SUBGROUP",
  NONE: "NONE",
  TEAM: "TEAM",
  INDIVIDUAL: "INDIVIDUAL",
};

export const VALIDATION = {
  MAX_SUBGROUP: 25,
  MAX_TEAM: 100,
};

export const MAX_LENGTH = {
  ASSIGNMENTS: 12,
};

export const SCHEDULE_SETTING_TYPE = reflectKeys(["START_DATE_INTERVAL", "DURATION"]);
export const SCHEDULE_SETTING_MSG_MAP = {
  START_DATE_INTERVAL: {
    title: "Apply Section Start Date Interval",
    description:
      "Schedule the number of weeks between the start date/time of consecutive Sections. The start date/time will be overridden for all Sections.",
    typeLabel: "SECTION START DATE INTERVAL",
    defaultWeeks: 0,
  },
  DURATION: {
    title: "Apply Section Duration",
    description:
      "Schedule Section duration for all Sections. The due date/time will be overridden for all Sections.",
    typeLabel: "SECTION DURATION",
    defaultWeeks: 1,
  },
};
export const STUDENT_LIST_VIEW = {
  DEFAULT_VIEW: "default-view",
  SUBGROUPS_VIEW: "subgroups-view",
};

export const SCHEDULE_LIST_ITEM = {
  NOW: "now",
  NONE: "none",
  SCHEDULE: "schedule",
};

export const DEFAULT_END_TIME = "11:59 PM";
export const MAX_ASSIGNEE_PER_ASSIGNMENT = 100;
export const MAX_ACTIVITY_TEAM_COUNT = 100;
export const MAX_LINKED_ASSIGNMENT_COUNT = 50;

export const SORT_FIELDS_LIST = ["startDate", "title.raw"];
export const STUDENTGROUP_RESOURCE_SORT_FIELDS_LIST = ["modifiedDate", "title.raw"];
export const ASSIGNMENTS_DUE_SORT_FIELDS_LIST = ["endDate", "title.raw"];
export const SORT_DIRECTIONS_LIST = ["descending", "ascending"];
export const ASSIGNMENTS_DUE_SORT_DIRECTIONS_LIST = ["ascending", "ascending"];

export const FILTER_OPTIONS = {
  CLASS_GROUP: "classGroup",
  ASSIGNMENT_STATUS: "assignmentStatus",
  MARK_STATUS: "markStatus",
  TYPE: "type",
  CATEGORY: "category",
  STATUS: "status",
  ACADEMIC_YEAR: "academicYear",
};

export const PROGRESS_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  OVERDUE: "OVERDUE",
  OVERDUE_SECTION: "OVERDUE_SECTION",
  OVERDUE_SOON: "OVERDUE_SOON",
  COMPLETE: "COMPLETE",
  UPCOMING: "UPCOMING",
};

export const ATTEMPT_PROGRESS_STATUS = {
  IN_COMPLETE: "Incomplete",
  COMPLETE: "Complete",
  OVERDUE: "Overdue",
};

export const ASSIGNMENT_STATUS_OPTIONS = {
  IN_PROGRESS: "Incomplete",
  OVERDUE: {
    ASSIGNMENT: "Overdue Assignments",
    ASSESSMENT: "Overdue Assessments",
  },
  OVERDUE_SECTION: "Overdue",
  OVERDUE_SOON: "Due within 3 Days",
  COMPLETED: "Complete",
  UPCOMING: "Upcoming",
};

export const TYPE_OPTIONS = {
  LESSON: "Lesson",
  COURSE: "Course",
};

export const ASSIGNMENT_TYPE = {
  LESSON: "LESSON",
  APP: "APP",
};

export const STUDENT_GROUP_RESOURCE_TYPE = {
  ASSIGNMENT: "ASSIGNMENT",
  CLASS_GROUP_RESOURCE: "CLASS_GROUP_RESOURCE",
};

export const ASSIGNMENT_STATUS = {
  DRAFT: "Draft",
};

export const TO_MARK = "To Be Marked";

export const ASSIGNMENT_TITLE_SETTINGS_TYPE = {
  LESSON: "LESSON",
  COURSE: "COURSE",
  ASSIGNMENT: "ASSIGNMENT",
};

export const FROM_LOCATION_TYPE = {
  STUDENT_GROUP: "STUDENT_GROUP",
  MY_DRIVE: "MY_DRIVE",
  HOME: "HOME",
  ALP_TEMPLATE: "ALP_TEMPLATE",
  MOE_LIBRARY: "MOE_LIBRARY",
  COMMUNITY_GALLERY: "COMMUNITY_GALLERY",
  CALENDAR: "CALENDAR",
};

export const FROM_EDITOR_PAGE_LOCATION = {
  COVER: "COVER",
  SECTION_COVER: "SECTION_COVER",
  ACTIVITY: "ACTIVITY",
};

export const LESSON_TEMPLATE_TAB_NAME = {
  NEW_LESSON: "new-lesson",
  NEW_COURSE: "new-course",
};

export const LESSON_TEMPLATE_SETTINGS_RANGE = {
  ACTIVITY_MIN: 1,
  ACTIVITY_MAX: 20,
  SECTION_MIN: 1,
  SECTION_MAX: 20,
};

export const DIRECT_CREATION_ACTION_TYPE = {
  ADD_NEW: "ADD_NEW",
  FROM_DRIVE: "FROM_DRIVE",
  FROM_LIBRARY: "FROM_LIBRARY",
  FROM_STARRED_RESOURCES: "FROM_STARRED_RESOURCES",
};

export const TEMPLATE_TYPE = {
  ALP_LESSON_TEMPLATE: "ALP_LESSON_TEMPLATE",
  ALP_COURSE_TEMPLATE: "ALP_COURSE_TEMPLATE",
  ALP_TEMPLATE: "ALP_TEMPLATE",
};

export const PAUSED_STATUS = {
  PAUSED: "Paused",
  AVAILABLE: "Available",
};

export const COMMON_SETTINGS_TYPE = {
  SCHEDULE: "Schedule",
  OTHER: "Other",
  GAMIFICATION: "Gamification",
};

export const DEFAULT_CREATE_MULTIPLE_TEAM_SIZE = 4;

export const RESUME_ASSIGNMENT_ERROR_CODE = {
  RESOURCE_LOCKED: "resource-locked",
  ASSIGNMENT_NOT_PAUSED: "AssignmentNotPaused",
  MISSING_BROWSER_TAB_UUID: "missing-browser-tab-uuid",
};

export const ASSIGNMENT_EVENTBUS_EVENT = {
  ASSIGNMENT_SETTINGS_UPDATED: "ASSIGNMENT_SETTINGS_UPDATED",
  ASSIGNMENT_SETTINGS_E_ASSESSMENT_CHANGED: "ASSIGNMENT_SETTINGS_E_ASSESSMENT_CHANGED",
};

export const ASSIGNMENT_SETTINGS_TAB = {
  STUDENT: "students-tab",
  SCHEDULE: "schedule-tab",
  ACCESS: "access-tab",
  GAMIFICATION: "gamification-tab",
  PERMISSION: "permission-tab",
  DEFAULT: "access-tab",
};

export const PENDING_ACTION_STATUS = {
  IN_PROGRESS: "In Progress",
  NEW: "New",
  COMPLETED: "Completed",
};

export const LEARNING_RESOURCE_TYPE = {
  LESSON: "Lesson",
  QUIZ: "Quiz",
};
